<template>
  <section class="info-section">
    <h3
      class="section-title"
      :class="{ 'section-title--empty': histories.length === 0 }"
    >
      EPDS回答履歴{{ histories.length === 0 ? ' 無し' : '' }}
    </h3>
    <table
      v-if="histories.length > 0"
      class="info-table"
    >
      <thead>
        <tr>
          <th>日時</th>
          <th>週数/月数</th>
          <th>合計</th>
          <th>設問10</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="epds in histories"
          :key="epds.id"
        >
          <td class="date-cell">
            {{ displayValue(epds.answeredAt) }}
          </td>
          <td>{{ displayValue(epds.period) }}</td>
          <td>
            {{ displayValue(epds.totalScore) }}
            <span
              v-if="epds.totalScore !== '-'"
              class="result-badge"
              :class="epds.positive ? 'result-badge--positive' : 'result-badge--negative'"
            >
              {{ epds.positive ? '陽性' : '陰性' }}
            </span>
          </td>
          <td>
            {{ displayValue(epds.question10Score) }}
            <span v-if="epds.question10Choice">{{ epds.question10Choice }}</span>
          </td>
          <td>
            <v-btn
              size="small"
              color="#33B5B4"
              prepend-icon="mdi-open-in-new"
              @click="$emit('open', epds.id)"
            >
              閲覧
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
defineProps({
  histories: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["open"]);

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #c8384f;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table thead {
  background: #efefef;
}

.info-table th,
.info-table td {
  text-align: left;
  border-bottom: 1px solid #e4e4e4;
  padding: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #333;
  vertical-align: top;
}

.info-table td.date-cell {
  color: #999;
}

.result-badge {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.result-badge--positive {
  background: #fdeaea;
  color: #c0392b;
}

.result-badge--negative {
  background: #f2f2f2;
  color: rgba(0, 0, 0, 0.6);
}

.section-title--empty {
  color: #888;
}

@media (max-width: 1280px) {
  .section-title {
    font-size: 15px;
  }

  .info-table th,
  .info-table td {
    font-size: 11px;
  }
}
</style>
